import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaSignOutAlt, FaExclamationTriangle } from 'react-icons/fa';
import './LogoutModal.css';

const LogoutModal = ({ show, onHide, onConfirm }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="logout-modal"
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header className="logout-modal-header">
                <Modal.Title className="logout-modal-title">
                    <FaExclamationTriangle className="logout-modal-icon" />
                    <span>אישור התנתקות</span>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="logout-modal-body">
                <div className="logout-modal-content">
                    <p className="logout-modal-message">
                        האם אתה בטוח שברצונך להתנתק מהמערכת?
                    </p>
                    <p className="logout-modal-subtitle">
                        תצטרך להתחבר מחדש כדי לגשת לדשבורד
                    </p>
                </div>
            </Modal.Body>

            <Modal.Footer className="logout-modal-footer">
                <Button
                    variant="outline-secondary"
                    onClick={onHide}
                    className="logout-modal-cancel-btn"
                >
                    ביטול
                </Button>
                <Button
                    variant="danger"
                    onClick={onConfirm}
                    className="logout-modal-confirm-btn"
                >
                    <FaSignOutAlt className="me-2" />
                    התנתק
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LogoutModal; 